import React from 'react';
import { useTranslation } from 'react-i18next';
import { IconFormNames, Image16 } from 'shared/assets/icons';
import { FormIcon } from 'shared/components/ui/form-icon';

import { useTaskDetailSubmenu } from '../../hooks/use-task-detail-submenu';
import { useData } from '../../use-data';
import * as Styled from './meta-icon.style';

export type MetaIconProps = {
  value: IconFormNames;
  onChange: (icon: IconFormNames) => void;
};

export const MetaIcon: React.FC<MetaIconProps> = ({ value, onChange }) => {
  const { t } = useTranslation();
  const { menuOpen, openMenu, closeMenu } = useTaskDetailSubmenu();
  const { createHabitIconAllowed, openPremiumDialog } = useData();

  const onIcon = (icon: IconFormNames) => {
    onChange?.(icon);
    closeMenu();
  };

  return (
    <Styled.Container>
      <Styled.LabelWrapper>
        <Styled.IconWrapper>
          <Image16 />
        </Styled.IconWrapper>
        <Styled.Label>{t('forms.habit.fields.icon.label')}</Styled.Label>
      </Styled.LabelWrapper>
      <FormIcon
        value={value}
        onChange={onIcon}
        isPremium={!createHabitIconAllowed}
        onPremium={openPremiumDialog}
        menuControl={{ menuOpen, openMenu, closeMenu }}
      />
    </Styled.Container>
  );
};
